import React, { useMemo } from 'react';

import Icon from '../../icons/Icon';
import CommonGroupedDropdown from '../../components/common-grouped-dropdown/CommonGroupedDropdown';
import { ICONS } from '../../icons';

import scss from './PredefineActions.module.scss';

function PredefineActions({ onSelectOption, selectedOption, options, placeholder, disabled }) {
  const selected = useMemo(
    () => options.flatMap((option) => option.options).find((option) => option.value === selectedOption),
    [options, selectedOption],
  );

  const IconComponent = useMemo(() => {
    if (!selected) {
      return null;
    }
    return <Icon icon={selected.Icon} />;
  }, [selected]);

  return (
    <div className={scss.wrapper}>
      <CommonGroupedDropdown
        groups={options}
        value={selectedOption}
        onSelect={onSelectOption}
        placeholder={placeholder}
        LeftIcon={IconComponent}
        withIcons
        disabled={disabled}
      />

      {selected?.description ? (
        <div className={scss.description}>
          <Icon icon={ICONS.Info} disableCommonStyles disableCommonColors className={scss.infoIcon} />
          {selected.description}
        </div>
      ) : null}
    </div>
  );
}

export default PredefineActions;
